$(function () {
  if (!customElements.get('global-discount')) {
    customElements.define(
      'global-discount',
      class globalDiscount extends HTMLElement {
        constructor() {
          super();
          this.shopMoneyFormat = window.shopMoneyFormat;
        }
        static get observedAttributes() {
          return ['data-total', 'data-price', 'data-type'];
        }

        attributeChangedCallback(name, oldValue, newValue) {
          if (oldValue === newValue) return;
          switch (name) {
            case 'data-total':
              this.total = JSON.parse(newValue);
              this.price = parseFloat(this.total.price);
              this.comparePrice = parseFloat(this.total.compare_price);
              this.updatePrice();
              break;
          }
        }
        connectedCallback() {
          this.type = this.getAttribute('data-type');
        }
        updatePrice() {
          console.log('this.comparePrice', this.comparePrice);
          console.log('this.price', this.price);
          if (this.price > 0 && this.comparePrice > 0) {
            if (this.type === 'quota') {
              this.discount = this.comparePrice - this.price;
              this.discountFormat = window.Shopify.formatMoney(this.discount, this.shopMoneyFormat);

              console.log('this.discount1', this.discount);
              // 将折扣值转换为整数后比较
              if (parseInt(this.discount) > 0) {
                document.querySelector('.compute-show').classList.remove('hidden');
                document.querySelector('.actual_discount-total-container').classList.remove('hidden');
                document.querySelector('.compute-show .quota-discount').textContent = this.discountFormat;
              } else {
                document.querySelector('.compute-show').classList.add('hidden');
                document.querySelector('.actual_discount-total-container').classList.add('hidden');
              }
            } else if (this.type === 'percentage') {
              this.discount = ((this.comparePrice - this.price) / this.comparePrice) * 100;
              this.discount = this.discount.toFixed(2);
              console.log('this.discount2', this.discount);

              // 将折扣值转换为整数后比较
              if (parseInt(this.discount) > 0) {
                document.querySelector('.compute-show').classList.remove('hidden');
                document.querySelector('.actual_discount-total-container').classList.remove('hidden');

                document.querySelector('.compute-show .scale-discount').textContent = this.discount;
              } else {
                document.querySelector('.compute-show').classList.add('hidden');
                document.querySelector('.actual_discount-total-container').classList.add('hidden');
              }
            }

            console.log('updatePrice-this.discount', this.discount);
            console.log('this.type', this.type);
          }
        }
      }
    );
  }
});
